<template>
  <div class="login-page">
    <!--    <img src="@/assets/ic_login_bg_1.jpg" class="login_left_bg">-->
    <div style="padding-top: 10vh">
      <div class="left_logo_box">
        <!-- <img v-if="isGZY" class="login_logo" style="height: 80px" src="@/assets/ic_login_logo_1.png" />
        <div>
          <img class="login_logo" src="@/assets/ic_login_logo_2.png" />
        </div> -->
      </div>
      <div class="right_login_box">
        <div class="top_blue_line"></div>
        <div class="center_content">
          <!-- <div v-if="isGZY" class="title">项目现场管理平台</div> -->
          <div v-if="isGZY" class="title">项目现场管理平台</div>
          <div class="login_or_register">
            <span class="lb_login" @click="optionMode = 1" v-if="optionMode !== 3" v-bind:style="{ fontSize: optionMode === 1 ? '24px' : '20px', color: optionMode === 1 ? '#3b8cff' : '#8ab0e6' }"
              >登录</span
            >
            <span v-if="optionMode !== 3" class="login_register_line">|</span>
            <span @click="optionMode = 2" class="lb_register" v-if="optionMode !== 3" v-bind:style="{ fontSize: optionMode === 2 ? '24px' : '20px', color: optionMode === 2 ? '#3b8cff' : '#8ab0e6' }"
              >注册</span
            >
            <span class="lb_findpwd" v-if="optionMode === 3" v-bind:style="{ fontSize: '24px', color: '#3b8cff' }">修改密码</span>
          </div>
          <div class="input_content">
            <!--登录-->
            <el-form v-if="optionMode === 1" :model="loginForm" :rules="rules" ref="loginForm" class="login-form" style="margin-top: 50px">
              <el-form-item prop="mobile">
                <LoginInput type="acc" placeholder="手机号" @onSubmitForm="onSubmitForm" v-model="loginForm.mobile" autocomplete="on" />
              </el-form-item>
              <el-form-item prop="pwd">
                <LoginInput type="pwd" placeholder="密码" @onSubmitForm="onSubmitForm" v-model="loginForm.pwd" autocomplete="on" />
              </el-form-item>
            </el-form>
            <!--注册、修改密码-->
            <el-form v-else :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
              <el-form-item prop="name">
                <LoginInput type="name" placeholder="姓名" v-model="loginForm.name" autocomplete="new-password" />
              </el-form-item>
              <el-form-item prop="mobile">
                <LoginInput type="acc" placeholder="手机号" v-model="loginForm.mobile" autocomplete="new-password" />
              </el-form-item>

              <el-form-item prop="verifyCode">
                <LoginInput type="verifyCode" placeholder :readonly="!isCanInputVerifyCode" v-model="loginForm.verifyCode" autocomplete="new-password" />
                <el-button @click="sendCode()" class="btn_code" type="primary" :disabled="dontClick">{{ !dontClick ? "获取验证码" : time + "秒后可重发" }}</el-button>
              </el-form-item>
              <el-form-item prop="pwd">
                <LoginInput type="pwd" placeholder="请输入密码" v-model="loginForm.pwd" autocomplete="new-password" />
              </el-form-item>
              <el-form-item prop="rePwd">
                <LoginInput type="pwd" placeholder="再次输入密码" v-model="loginForm.rePwd" autocomplete="new-password" />
              </el-form-item>
            </el-form>
          </div>

          <div class="to_login">
            <el-button class="btn_login" @click="loginPost" v-bind:style="{ background: isInputNotNullPwd ? 'rgba(33, 200, 179,1)' : 'rgba(33, 200, 179,0.6)' }">{{
              optionMode === 1 ? "登录" : optionMode === 2 ? "注册" : "完成并登录"
            }}</el-button>
            <div class="bottom_register_findpwd">
              <span class="btn_register">
                {{ optionMode === 1 ? "没有账号?" : optionMode === 2 ? "我有账号" : "" }}
                <span class="a_btn_register" @click="optionMode = optionMode === 1 ? 2 : 1">{{ optionMode === 1 ? "点我注册" : "点我登录" }}</span>
              </span>
              <span class="btn_findpwd" v-if="optionMode !== 3" @click="optionMode = 3">忘记密码</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="isGZY" class="bottom_copyright">©贵州工之友科技有限公司</div> -->
  </div>
</template>

<script>
import LoginInput from "@/components/login/login-input";

import { login, resetPassword, sendPwdResetCodeMsg, sendResetPwdVerifyCode, sendCode, register } from "@/api/api.js";

import { IsNullOrEmpty, setCookie, setLoginUserInfo } from "@/utils/m-utils.js";

import { _realmName } from "@/utils/axios/request";

export default {
  name: "login",
  components: {
    LoginInput,
  },
  data() {
    //自定义登录密码验证规则
    let validatorPwd = (rule, value, callback) => {
      if (!value) {
        this.isInputNotNullPwd = false;
        callback(new Error("请输入登录密码"));
      } else {
        this.isInputNotNullPwd = true;
        callback();
      }
    };
    //自定义注册再次输入密码验证规则
    let validatorRePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入密码"));
      } else if (this.loginForm.pwd !== value) {
        callback(new Error("两次输入不一致"));
      } else {
        callback();
      }
    };
    return {
      isGZY: true, //是否工之友登录   true显示工之友相关内容   false不显示工之友相关内容
      isCanInputVerifyCode: false,
      time: 0,
      second: 60,
      dontClick: false, //不能点击
      loginForm: {
        name: "",
        mobile: "",
        pwd: "",
        verifyCode: "",
        rePwd: "",
      },
      optionMode: 1, //1登录，2注册，3找回密码
      isInputNotNullPwd: false,
      linkType: "", //跳转页面  路由参数    https://base.gzybia.com/login/concrete
      rules: {
        pwd: [
          {
            required: true,
            validator: validatorPwd,
            trigger: "change",
          },
        ],
        rePwd: [
          {
            required: true,
            validator: validatorRePwd,
            trigger: "change",
          },
        ],
        mobile: [
          {
            pattern: /^1[23456789]\d{9}$/,
            required: true,
            message: "请输入正确的手机",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "change",
          },
        ],
        verifyCode: [
          {
            max: 4,
            min: 4,
            required: true,
            message: "请输入4位验证码",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    run: function () {
      //准备倒计时
      this.dontClick = true; //运行时不可点击
      this.time = this.second;
      this.timer();
    },
    stop: function () {
      //停止
      this.time = 0;
      this.dontClick = false; //停止后可点击
    },
    timer: function () {
      //启动倒计时定时器
      if (this.time > 0) {
        this.time--;
        setTimeout(this.timer, 1000);
      } else {
        //停止倒计时
        this.stop();
      }
    },
    async loginPost() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          switch (this.optionMode) {
            case 1: //登录
              this.loginSvr();
              break;
            case 2: //注册
              this.register();
              break;
            case 3: //修改密码
              this.updatePwd();
              break;
          }
        } else {
          return false;
        }
      });
    },
    async updatePwd() {
      const result = await resetPassword(this.loginForm);
      if (result.code === "0") {
        sessionStorage.setItem("accessToken", result.data.sessionKey);
        localStorage.setItem("selCompany", result.data.tenantId);
        setCookie("accessToken", result.data.sessionKey, 0, _realmName); //设置cookie，用于单点登录
        setCookie("userId", result.data.userDto.userId, 0, _realmName);
        setCookie("tenantId", result.data.tenantId, 0, _realmName);
        setLoginUserInfo(result.data);
        this.clearFrom();
        if (result.data.needAddTenant === 0) {
          //个人用户需要去到完善企业信息
          this.gotoPefectInfoPage();
        } else {
          this.$router.push("/base/home");
        }
      }
    },
    async register() {
      const jsonData = await register(this.loginForm);
      // console.log(jsonData);
      if (jsonData.code === "0") {
        sessionStorage.setItem("phone", this.loginForm.mobile);
        sessionStorage.setItem("pwd", this.loginForm.pwd);
        sessionStorage.setItem("accessToken", jsonData.data.sessionKey);
        setCookie("accessToken", jsonData.data.sessionKey, 0, _realmName); //设置cookie，用于单点登录
        this.clearFrom();
        //注册成功，跳转到完善信息页面
        this.gotoPefectInfoPage();
      }
    },
    async sendCode() {
      this.isCanInputVerifyCode = true; //点击之后才可输入验证码
      if (this.optionMode === 2) {
        //registerChannel=2表示发送类型为pc【0微信公众号，1:app,2:pc】
        const jsonData = await sendCode({ mobile: this.loginForm.mobile, registerChannel: 2 });
        // console.log(jsonData);
        if (jsonData) {
          if (jsonData.code === "0") {
            this.$message("验证码发送成功");
            this.run();
          } else {
            this.$message(jsonData.msg);
          }
        }
      } else if (this.optionMode === 3) {
        this.sendResetPwdVerifyCode();
      }
    },
    async sendResetPwdVerifyCode() {
      //发送重置密码验证码
      //registerChannel=2表示发送类型为pc【0微信公众号，1:app,2:pc】
      const jsonData = await sendPwdResetCodeMsg({ mobile: this.loginForm.mobile });
      // console.log(jsonData);
      if (jsonData.code === "0") {
        this.$message("验证码发送成功");
        this.run();
      } else {
        this.$message(jsonData.msg);
      }
    },
    async loginSvr() {
      const loginBack = await login(this.loginForm);
      // console.log(loginBack.data);
      localStorage.setItem("selCompany", loginBack.data.tenantId);
      sessionStorage.setItem("accessToken", loginBack.data.sessionKey);
      setCookie("accessToken", loginBack.data.sessionKey, 0, _realmName); //设置cookie，用于单点登录
      setCookie("userId", loginBack.data.userDto.userId, 0, _realmName);
      setCookie("tenantId", loginBack.data.tenantId, 0, _realmName);
      setLoginUserInfo(loginBack.data);
      this.clearFrom();
      if (loginBack.data.needAddTenant === 0) {
        //个人用户需要去到完善企业信息
        this.gotoPefectInfoPage();
      } else {
        this.initSys();
      }
    },
    clearFrom() {
      this.loginForm.verifyCode = "";
      this.loginForm.mobile = "";
      this.loginForm.pwd = "";
      this.loginForm.rePwd = "";
    },
    gotoPefectInfoPage() {
      this.$router.push("/perfectInfo");
    },
    onSubmitForm() {
      this.loginPost();
    },
    initSys() {
      //判断是从哪个登录模式进来的 跳转到不同的页面
      if (IsNullOrEmpty(this.linkType)) {
        this.$router.push({ path: "/base/home", query: { label: "我的首页" } });
      } else if (this.linkType === "concrete") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "http://192.168.0.140:9005";
        } else {
          window.location.href = "https://concrete.gzybia.com";
        }
      } else if (this.linkType === "equipment") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "http://192.168.0.140:9001";
        } else {
          window.location.href = "https://equipment.gzybia.com";
        }
      } else if (this.linkType === "oilcan") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "http://192.168.0.140:9002";
        } else {
          window.location.href = "https://oilcan.gzybia.com";
        }
      } else if (this.linkType === "steel") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "http://192.168.0.140:9003";
        } else {
          window.location.href = "https://steel.gzybia.com";
        }
      } else if (this.linkType === "bang") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "http://192.168.0.140:9006";
        } else {
          window.location.href = "https://bang.gzybia.com";
        }
      } else if (this.linkType === "tunnel") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "http://192.168.0.140:9007";
        } else {
          window.location.href = "https://tunnel.gzybia.com";
        }
      } else if (this.linkType === "labour") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "http://192.168.0.140:9004";
        } else {
          window.location.href = "https://labour2.gzybia.com";
        }
      }
      //这个是适配路桥集团的
      else {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "http://192.168.0.140:9007";
        } else {
          window.location.href = "https://tunnel.gzybia.com";
        }
      }
    },
  },
  watch: {
    optionMode: function () {
      // console.log(this.optionMode);
      if (this.optionMode !== 2) {
        this.isCanInputVerifyCode = false;
      }
    },
  },
  created() {
    // this.linkType = this.$route.params.linkType;
    //如果路由参数为空  显示工之友相关登录页   参数不为空显示无工之友相关登录页
    const linkType = this.$route.params.linkType;
    const isGzyArr = ["equipment", "oilcan", "steel", "concrete", "bang", "tunnel", "labour"];
    if (IsNullOrEmpty(linkType)) {
      this.isGZY = true;
    }
    //判断是否显示工之友相关内容
    else if (isGzyArr.indexOf(linkType) > -1) {
      this.isGZY = true;
    } else {
      this.isGZY = false;
    }
    this.linkType = linkType;

    //判断是否有token，免登陆
    this.$nextTick(() => {
      if (!IsNullOrEmpty(sessionStorage.getItem("accessToken"))) {
        this.initSys();
      }
    });
  },
};
</script>
<style lang="scss">
.input_content {
  margin: 20px 45px;

  .el-form-item.is-error .el-input__inner,
  .el-form-item.is-error .el-input__inner:focus,
  .el-form-item.is-error .el-textarea__inner,
  .el-form-item.is-error .el-textarea__inner:focus,
  .el-message-box__input input.invalid,
  .el-message-box__input input.invalid:focus {
    border: 1px solid #ffffff;
    border-bottom: 2px solid #f56c6c;
  }

  .el-form-item.is-success .el-input__inner,
  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner,
  .el-form-item.is-success .el-textarea__inner:focus {
    border: 1px solid #ffffff;
    border-bottom: 2px solid #67c23a;
  }
}
</style>
<style scoped lang="scss">
.btn_code {
  position: absolute;
  top: 0px;
  right: 10px;
}

.login_logo {
  margin-top: 10%;
  margin-left: 10%;
}

.left_logo_box {
  width: 70vw;
  height: 620px;
  margin-left: 10vw;
  background-color: rgba(0, 0, 0, 0.1);
  position: absolute;
}

.bottom_register_findpwd {
  text-align: start;
  margin-left: 45px;
  margin-right: 45px;
  margin-top: 20px;
}

.a_btn_register {
  text-decoration: underline;
  cursor: pointer;
}

.btn_login {
  width: 80%;
  margin-left: 45px;
  margin-right: 45px;
  background: rgba(33, 200, 179, 0.8);
  color: #ffffff;
  font-size: 24px;
  font-family: "Microsoft YaHei";
}

.to_login {
  text-align: center;
}

.login-page {
  width: 100vw;
  height: 100vh;
  background-color: #313a4b;
  background-image: url("../../assets/ic_login_bg_1.jpg");
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
}

.login_left_bg {
  width: 50vw;
  margin: 70px;
}

.bottom_copyright {
  color: #ffffff;
  text-align: center;
  position: fixed;
  left: 44vw;
  top: 95vh;
}

.right_login_box {
  width: 424px;
  height: 64vh;
  float: right;
  position: relative;
  right: 10vw;
}

.top_blue_line {
  width: 100%;
  height: 4px;
  background: #3b8cff;
  box-shadow: 1px 2px 5px #888888;
  position: absolute;
  z-index: 1;
}

.center_content {
  width: 96%;
  /*height: 100%;*/
  height: 620px;
  background-color: #ffffff;
  margin-left: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
}

.center_content::-webkit-scrollbar {
  display: none;
}

.title {
  font-size: 24px;
  text-align: center;
  font-weight: bold;
  color: #282828;
  font-family: "Microsoft YaHei";
  margin-top: 45px;
}

.login_or_register {
  margin-top: 30px;
  text-align: center;
  font-weight: bold;
}

.lb_login,
.lb_register {
  cursor: pointer;
  font-family: "Microsoft YaHei";
  font-size: 24px;
  font-weight: bold;
}

.btn_register,
.btn_findpwd {
  font-family: "Microsoft YaHei";
  font-size: 14px;
  color: #3b8cff;
}

.btn_findpwd {
  float: right;
  cursor: pointer;
}

.lb_register {
  color: #8ab0e6;
}

.lb_login {
  color: #3b8cff;
}

.login_register_line {
  font-size: 24px;
  color: #8ab0e6;
  margin-left: 30px;
  margin-right: 30px;
}
</style>




// WEBPACK FOOTER //
// src/pages/login/login.vue